module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-wrapper"
  }, [_c('div', {
    staticStyle: {
      "font-family": "'Roboto Thin'",
      "font-size": "16px",
      "padding-bottom": "3px",
      "padding-right": "5px",
      "margin-bottom": "15px",
      "border-bottom": "solid 1px #ddd",
      "float": "left"
    }
  }, [_vm._v("Редактирование свойств доски")]), _vm._v(" "), (_vm.editingTaskBoard != null) ? _c('div', [_c('div', {
    staticStyle: {
      "width": "100%",
      "font-family": "'Roboto Thin'",
      "font-size": "16px",
      "padding-bottom": "5px",
      "float": "left"
    }
  }, [_vm._v("\n      Доска:\n      "), _c('Input', {
    staticStyle: {
      "width": "585px"
    },
    attrs: {
      "size": "large"
    },
    model: {
      value: (_vm.editingTaskBoard.name),
      callback: function($$v) {
        _vm.editingTaskBoard.name = $$v
      },
      expression: "editingTaskBoard.name"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "font-family": "'Roboto Thin'",
      "font-size": "16px",
      "padding-bottom": "5px",
      "float": "left"
    }
  }, [_vm._v("\n      Участники:\n      "), _c('Select', {
    staticStyle: {
      "width": "550px"
    },
    attrs: {
      "multiple": "",
      "filterable": "",
      "size": "large",
      "placeholder": "Выберите участников"
    },
    model: {
      value: (_vm.editingTaskBoard.members),
      callback: function($$v) {
        _vm.editingTaskBoard.members = $$v
      },
      expression: "editingTaskBoard.members"
    }
  }, _vm._m(0))], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "30px 0px 0px 0px",
      "float": "left"
    }
  }, [_c('Button', {
    staticStyle: {
      "border-radius": "3px",
      "margin-bottom": "10px"
    },
    attrs: {
      "type": "warning"
    },
    on: {
      "click": _vm.saveOnClick
    }
  }, [_vm._v("Сохранить")]), _vm._v(" "), _c('Button', {
    staticStyle: {
      "border-radius": "3px",
      "margin-bottom": "10px"
    },
    attrs: {
      "type": "ghost"
    },
    on: {
      "click": _vm.cancelOnClick
    }
  }, [_vm._v("Отменить")])], 1)]) : _c('div', {
    staticStyle: {
      "width": "100%",
      "padding-top": "20px",
      "float": "left"
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/tasks"
    }
  }, [_vm._v("Вернуться к списку задач")])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._l((_vm.commonData.users), function(user, userKey) {
    return _c('Option', {
      key: userKey,
      attrs: {
        "value": user.id
      }
    }, [_vm._v(_vm._s(user.Name))])
  })
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-15b7b89c","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Tasks/TaskBoardSettings.vue
// module id = 389
// module chunks = 0